import { createContext, Dispatch, FC, SetStateAction, useState } from 'react';
interface IModalContentContext {
  isBottomReached: boolean;
  setIsBottomReached: Dispatch<SetStateAction<boolean>>;
  isTopReached: boolean;
  setIsTopReached: Dispatch<SetStateAction<boolean>>;
  scrollPercent: number;
  setScrollPercent: Dispatch<SetStateAction<number>>;
  lockBodyScroll: boolean;
}
export const ModalContentContext = createContext<IModalContentContext>({
  isBottomReached: true,
  setIsBottomReached: () => true,
  isTopReached: true,
  setIsTopReached: () => true,
  scrollPercent: 0,
  setScrollPercent: () => 0,
  lockBodyScroll: true
});
type IModalContentProvider = {
  lockBodyScroll: boolean;
  children: React.ReactNode;
};
export const ModalContentProvider: FC<IModalContentProvider> = ({
  children,
  lockBodyScroll
}) => {
  const [isBottomReached, setIsBottomReached] = useState(true);
  const [isTopReached, setIsTopReached] = useState(true);
  const [scrollPercent, setScrollPercent] = useState(0);
  return <ModalContentContext.Provider value={{
    isBottomReached,
    setIsBottomReached,
    isTopReached,
    setIsTopReached,
    scrollPercent,
    setScrollPercent,
    lockBodyScroll
  }} data-sentry-element="ModalContentContext.Provider" data-sentry-component="ModalContentProvider" data-sentry-source-file="ModalContentContext.tsx">
      {children}
    </ModalContentContext.Provider>;
};